import React from 'react';
import {Text} from '../Text';
import { tagShapes, tagSizesPx, tagTemplates } from 'config/tags';
import { pink } from 'config/colors';

export default tag => {
  const {
    title, 
    buildingPreview, 
    preview, 
    placeholder, 
    useTemplate=true, 
    style={}, 
    onError, 
    maxSize=400,
    template,
    loading,
  } = tag;
  const shape = tag.shape ? tag.shape : 
                tag.variant ? tagShapes[tag.variant.id] : 
                "round";
  
  let size = {
    width: maxSize,
    height: maxSize,
  };
  if(style.width && style.height) {
    size = {width:style.width, height:style.height};
  }
  else if(style.width) {
    if(shape === "round" || shape === "square") {
      size = {
        width: style.width,
        height: style.width,
      };
    }
    if(shape === "rectH") {
      size = {
        width: style.width,
        height: style.width * 0.6279,
      };
    }
    if(shape === "rectV") {
      size = {
        width: style.width,
        height: style.width / 0.6279,
      };
    }
  }
  else if(style.height) {
    if(shape === "round" || shape === "square") {
      size = {
        width: style.height,
        height: style.height,
      };
    }
    if(shape === "rectH") {
      size = {
        width: style.height / 0.6279,
        height: style.height,
      };
    }
    if(shape === "rectV") {
      size = {
        width: style.height * 0.6279,
        height: style.height,
      };
    }
  }
  else if(tag.variant) {
    size = {...tagSizesPx[tag.variant.id]};
  }
  
  let sizeMult = tag.sizeMult;
  if(!sizeMult) {
    if(style.width && tag.variant) {
      sizeMult = parseInt(size.width, 10) / parseInt(tagSizesPx[tag.variant.id].width, 10);
    }
    if(style.height && tag.variant) {
      sizeMult = parseInt(size.height, 10) / parseInt(tagSizesPx[tag.variant.id].height, 10);
    }
    else {
      sizeMult = maxSize / Math.max(parseInt(size.width, 10), parseInt(size.height, 10));
    }
  }
  sizeMult = Math.min(sizeMult, 1);
  
  if(!style.width && !style.height) {
    size.width = parseInt(size.width, 10) * sizeMult + "px";
    size.height = parseInt(size.height, 10) * sizeMult + "px";
  }

  const borderRadius = shape === "round" ? "50%" : 0;
  
  if(template) {
    return (
      <div 
        style={{
          backgroundColor:"#fafafa", 
          borderRadius, 
          overflow: 'hidden',
          ...size, 
          ...style
        }}
        dangerouslySetInnerHTML={{__html:tagTemplates[tag.variant.id]({
          ...template,
          fontSize: template.fontSize * sizeMult,
        })}}
      />
    );
  }
  
  if(loading || buildingPreview) {
    return (
      <div style={{backgroundColor:"#fafafa", display:'inline-flex', alignItems:'center', justifyContent:'center', borderRadius, ...size, ...style}}>
        <Text small bold>loading...</Text>
      </div>
    );
  }
  
  if(preview) {
    return <img src={preview} alt="preview" style={{objectFit:'cover', backgroundColor:"#fafafa", borderRadius, ...size, ...style}} onError={onError}/>;
  }
  
  if(placeholder) {
    if(useTemplate) {
      return (
        <div 
          style={{
            backgroundColor:"#fafafa", 
            borderRadius, 
            overflow: 'hidden',
            ...size, 
            ...style
          }}
          dangerouslySetInnerHTML={{__html:tagTemplates[tag.variant.id]({
            message:"", 
            logo: "",
            color: "#ffffff",
            logoWidth: 50,
            fontSize: 50 * sizeMult,
            background: `url(${placeholder})`,
          })}}
        />
      );
    }
    return <img src={placeholder} alt="preview"  onError={onError}/>;
  }
  
  if(tag.variant) {
    return (
      <div 
        style={{
          backgroundColor:"#fafafa", 
          borderRadius, 
          overflow: 'hidden',
          ...size, 
          ...style
        }}
        dangerouslySetInnerHTML={{__html:tagTemplates[tag.variant.id]({
          color: pink,
          message: title || tag.variant.title || shape.toUpperCase(), 
          logo: "",
          logoWidth: 50,
          fontSize: 50 * sizeMult,
          background: "#ffffff",
        })}}
      />
    );
  }
  
  return (
    <div 
      style={{
        backgroundColor:"#fafafa", 
        display:'flex', 
        alignItems:'center', 
        justifyContent:'center', 
        borderRadius, 
        ...size, 
        ...style
      }}>
      <Text size={12 * sizeMult} color={pink} block style={{maxWidth:"80%", textAlign:'center'}}>
        {title || tag.variant ? tag.variant.title : shape.toUpperCase()}
      </Text>
    </div>
  );
};